import { createRouter, createWebHashHistory } from 'vue-router'
import { modules } from '@/config/modules'
import HomeView from '@/views/HomeView.vue'
import LoginView from '@/views/LoginView.vue'
import ModuleView from '@/views/ModuleView.vue'
import ReportView from '@/views/ReportView.vue'

// 14个列表模块路由:统一复用 ModuleView,通过 meta.moduleKey 区分
const listRoutes = modules
  .filter(m => !m.isGroup)
  .map(m => ({
    path: m.path,
    name: m.key,
    component: ModuleView,
    meta: { moduleKey: m.key, title: m.name }
  }))

// 统计报表子路由:/report/sales、/report/stock ...
const reportRoutes = (modules.find(m => m.key === 'report')?.children || [])
  .map(r => ({
    path: r.path,
    name: r.key,
    component: ReportView,
    meta: { reportKey: r.path.split('/').pop(), title: r.name }
  }))

const routes = [
  { path: '/login', name: 'login', component: LoginView, meta: { title: '登录', public: true } },
  { path: '/', name: 'home', component: HomeView, meta: { title: '首页' } },
  ...listRoutes,
  ...reportRoutes,
  { path: '/:pathMatch(.*)*', redirect: '/' }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

// 未登录时统一跳转到登录页
router.beforeEach(to => {
  if (!to.meta.public && !localStorage.getItem('logged_in')) {
    return { path: '/login', query: { redirect: to.fullPath } }
  }
  return true
})

router.afterEach(to => {
  document.title = to.meta.title ? `${to.meta.title} - 种鸡育种管理系统` : '种鸡育种管理系统'
})

export default router
